// extracted by mini-css-extract-plugin
export default {"root":"SettingsPage_root__8CQLD","titleWrapper":"SettingsPage_titleWrapper__g0XSB","fitContent":"SettingsPage_fitContent__8LO2s"};